export var ECommentPostType;
(function (ECommentPostType) {
    ECommentPostType["COMMENTS_CONNECTION"] = "COMMENTS_CONNECTION";
    ECommentPostType["COMMENT"] = "COMMENT";
})(ECommentPostType || (ECommentPostType = {}));
export const getDefaultCommentContent = () => ({ body: '' });
